import { render, staticRenderFns } from "./ProjectDetailsFull.vue?vue&type=template&id=0e4bf5e3&scoped=true"
import script from "./ProjectDetailsFull.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsFull.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailsFull.vue?vue&type=style&index=0&id=0e4bf5e3&prod&scoped=true&lang=css"
import style1 from "./ProjectDetailsFull.vue?vue&type=style&index=1&id=0e4bf5e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4bf5e3",
  null
  
)

export default component.exports